

// //

// import axios from "axios";
// // 1. IMPORTAMOS LA CONFIGURACIÓN CENTRALIZADA
// import { API } from "../components/config"; 

// const axiosAuth = axios.create({
//   baseURL: API, // <-- Ahora usa "http://3.236.217.225/api" (vía Nginx)
//   withCredentials: true,
//   timeout: 15000,
// });

// // 🔥 SET TOKEN INICIAL
// const tokenInicial = localStorage.getItem("token");
// if (tokenInicial) {
//   axiosAuth.defaults.headers.common["Authorization"] = `Bearer ${tokenInicial}`;
// }

// // 👉 REQUEST INTERCEPTOR
// axiosAuth.interceptors.request.use(
//   (config) => {
//     const token = localStorage.getItem("token");

//     if (token) {
//       config.headers.Authorization = `Bearer ${token}`;
//     } else if (!config.url.includes("/auth")) {
//       console.warn("⚠️ Request sin token:", config.url);
//     }

//     return config;
//   },
//   (error) => Promise.reject(error)
// );

// // 👉 RESPONSE INTERCEPTOR
// axiosAuth.interceptors.response.use(
//   (response) => response,
//   async (error) => {
//     const originalRequest = error.config;

//     if (!error.response) {
//       console.error("❌ Error de red o servidor caído");
//       return Promise.reject(error);
//     }

//     // 🔥 401 → intentar refresh de token
//     if (
//       error.response.status === 401 &&
//       !originalRequest._retry &&
//       !originalRequest.url.includes("/auth/refresh")
//     ) {
//       originalRequest._retry = true;

//       try {
//         // Usamos la API centralizada aquí también
//         const res = await axios.post(
//           `${API}/auth/refresh`,
//           {},
//           { withCredentials: true }
//         );

//         const newToken = res.data.token;

//         if (!newToken) throw new Error("No token recibido");

//         localStorage.setItem("token", newToken);

//         axiosAuth.defaults.headers.common["Authorization"] = `Bearer ${newToken}`;
//         originalRequest.headers.Authorization = `Bearer ${newToken}`;

//         return axiosAuth(originalRequest);

//       } catch (refreshError) {
//         console.error("❌ Sesión expirada");

//         localStorage.removeItem("token");
//         localStorage.removeItem("user");

//         if (window.location.pathname !== "/login") {
//           window.location.href = "/login";
//         }

//         return Promise.reject(refreshError);
//       }
//     }

//     return Promise.reject(error);
//   }
// );

// export default axiosAuth;

//

import axios from "axios";
import { API } from "../components/config";

const axiosAuth = axios.create({
  baseURL: API,
  withCredentials: true,
  timeout: 120000, // 🔥 2 minutos para procesos pesados
});

/* ================= TOKEN INICIAL ================= */
const tokenInicial = localStorage.getItem("token");

if (tokenInicial) {
  axiosAuth.defaults.headers.common["Authorization"] = `Bearer ${tokenInicial}`;
}

/* ================= REQUEST INTERCEPTOR ================= */
axiosAuth.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else if (!config.url?.includes("/auth")) {
      console.warn("⚠️ Request sin token:", config.url);
    }

    return config;
  },
  (error) => Promise.reject(error)
);

/* ================= RESPONSE INTERCEPTOR ================= */
axiosAuth.interceptors.response.use(
  (response) => response,

  async (error) => {
    const originalRequest = error.config || {};

    /* ===== ERROR DE RED / TIMEOUT / NGINX / CORS ===== */
    if (!error.response) {
      console.error("❌ ERROR SIN RESPUESTA DEL SERVIDOR");
      console.error("➡ URL:", originalRequest.baseURL + originalRequest.url);
      console.error("➡ Motivo:", error.message);

      return Promise.reject(error);
    }

    /* ===== TOKEN EXPIRADO ===== */
    if (
      error.response.status === 401 &&
      !originalRequest._retry &&
      !originalRequest.url?.includes("/auth/refresh")
    ) {
      originalRequest._retry = true;

      try {
        const res = await axios.post(
          `${API}/auth/refresh`,
          {},
          { withCredentials: true, timeout: 15000 }
        );

        const newToken = res.data?.token;

        if (!newToken) {
          throw new Error("No token recibido");
        }

        localStorage.setItem("token", newToken);

        axiosAuth.defaults.headers.common["Authorization"] = `Bearer ${newToken}`;
        originalRequest.headers.Authorization = `Bearer ${newToken}`;

        console.log("🔄 Token refrescado correctamente");

        return axiosAuth(originalRequest);

      } catch (refreshError) {
        console.error("❌ Sesión expirada o refresh inválido");

        localStorage.removeItem("token");
        localStorage.removeItem("user");

        if (window.location.pathname !== "/login") {
          window.location.href = "/login";
        }

        return Promise.reject(refreshError);
      }
    }

    /* ===== OTROS ERRORES BACKEND ===== */
    console.error("❌ ERROR BACKEND:", {
      url: originalRequest.baseURL + originalRequest.url,
      status: error.response.status,
      data: error.response.data
    });

    return Promise.reject(error);
  }
);

export default axiosAuth;
